import { useState, useMemo } from 'react';
import useImageView from '~/components/casino-shared/tournaments/utils/use-image-view';
import CardMedia from '@comeon/ui/src/cards/base/card-media';
import LazyLoadImage from '~/components/utilities/lazyload-image';

export interface Image {
	path: string;
	file: string;
}

interface EnhancedImageProps {
	image: Image;
	otherView?: Image;
	alt: string;
	sizes?: string;
}

export default function EnhancedImage({ image, otherView, alt, sizes }: EnhancedImageProps) {
	const [isVideoLoaded, setIsVideoLoaded] = useState(false);
	const { srcSet, formats, smallestSrc } = useImageView(image);

	const imageNode = useMemo(
		() => (
			<LazyLoadImage
				alt={alt}
				src={smallestSrc}
				srcSet={srcSet}
				pictureElementData={formats}
				sizes={sizes}
				onLoad={undefined}
				smartImage={undefined}
			/>
		),
		[alt, srcSet, formats, smallestSrc, sizes]
	);

	const videoNode = useMemo(
		() => (
			<LazyLoadImage
				alt={alt}
				src={otherView ? `${otherView.path}/${otherView.file}` : ''}
				onLoad={
					(() => {
						setIsVideoLoaded(true);
					}) as unknown as undefined
				}
				sizes={sizes}
				pictureElementData={undefined}
				smartImage={undefined}
				lazyload
			/>
		),
		[alt, otherView, sizes]
	);

	return (
		<CardMedia
			src={smallestSrc}
			srcSet={srcSet}
			imageComponent={imageNode}
			videoComponent={otherView && videoNode}
			showVideo={isVideoLoaded}
			sizes={sizes}
			lazyload
		/>
	);
}
